import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'admin/usuarios',
		component: Base,
		children: [
			{
				path: '',
				name: 'UsuariosList',
				component: List,
				meta: {
					path: '/admin/usuarios',
					pai: 'Admin',
					title: 'Admin - Usuários',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Usuários',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'UsuariosNovo',
				component: Form,
				meta: {
					path: '/admin/usuarios',
					pai: 'Admin',
					title: 'Admin - Usuários - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Usuários',
						class: '',
						active: false,
						url: '/admin/usuarios'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'UsuariosEditar',
				component: Form,
				meta: {
					path: '/admin/usuarios',
					pai: 'Admin',
					title: 'Admin - Usuários - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Usuários',
						class: '',
						active: false,
						url: '/admin/usuarios'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]